import { CustomCellRendererProps } from 'ag-grid-react';
import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { ReactElement } from 'react';
import { EmptyCell } from '../../formatters/genericFormatters';

export interface FaultsRendererValue {
  count?: number;
  level?: number;
}

export function FaultsRenderer<T>({
  value,
}: CustomCellRendererProps<T, FaultsRendererValue>): ReactElement | string {
  if (value && typeof value.count !== 'undefined') {
    let status = BadgeStatus.Neutral; // Default to unknown status.

    if (value.count === 0) {
      status = BadgeStatus.Healthy;
    } else if (typeof value.level === 'number' && value.level > 0) {
      switch (value.level) {
        case 1:
          status = BadgeStatus.Danger;
          break;
        case 2:
          status = BadgeStatus.Warning;
          break;
        case 3:
          status = BadgeStatus.Caution;
          break;
      }
    }

    return <StatusCell label={`${value.count}`} status={status} />;
  }

  return EmptyCell;
}

export default FaultsRenderer;
